import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutDeductCodeInvoiceXref extends Layout {
    buttonDeductionExpand: Button;
    horizontalspacer1: HorizontalSpacer;
    labelDeductions: Label;
    panelDeductCode: Panel;
    panelDeductionButtons: Panel;
    panelDeductionCollapse: Panel;
    sourceDeductCodeEdi: DataSource;
    tableDeductions: Table;
}
